module.exports = __webpack_public_path__ + "img/Component 19.3696a3b8.png";